import _get from 'lodash-es/get';
import { put } from 'redux-saga/effects';
import {
  createGroupFailed,
  createGroupSuccess,
  getAllGroupsFailed,
  getAllGroupsSuccess,
  getGroupDetailsFailed,
  getGroupDetailsSuccess,
  setUploadMsg,
} from '../../actions/groups';
import {
  GET_ALL_GROUPS,
  GET_GROUP_DETAILS,
  CREATE_GROUP_URL,
} from '../../constants/urls';
// import { clearInputValue } from '../../helpers';
import {
  groupUploadMsg,
  genericErrorMsg,
} from '../../pages/common/components/constants';
import zfetch, {
  METHOD_GET,
  METHOD_POST,
} from '../../pages/common/utils/zfetch';
import { openErrorToast } from '../../reducers/uiLogic';

const getAllGroups = ({ workspaceId, flowType }) => {
  const options = {
    method: METHOD_GET,
    params: { workspace_id: workspaceId, flow_type: flowType },
  };
  return zfetch(GET_ALL_GROUPS, options);
};

export function* getAllGroupsSaga(action) {
  let groupsData = {};
  try {
    const response = yield getAllGroups(action.payload);
    const jsonResponse = yield response.json();
    const { data } = jsonResponse;
    groupsData = data;
  } catch (error) {
    let err = error;
    if (error.response) {
      err = yield err.response;
    }
    yield put(getAllGroupsFailed(err));
    yield put(openErrorToast('Failed to get teams!'));
    return;
  }

  yield put(getAllGroupsSuccess(groupsData));
}

const createGroup = ({ fileBody, workspaceId, flowType }) => {
  const options = {
    body: fileBody,
    method: METHOD_POST,
    params: { workspace_id: workspaceId, flow_type: flowType },
  };
  return zfetch(CREATE_GROUP_URL, options);
};

export function* createGroupSaga(action) {
  let newGroup = {};

  try {
    const response = yield createGroup(action.payload);
    const jsonResponse = yield response.json();
    const {
      success = false,
      data: { process_id: processId = '', message = {} },
    } = jsonResponse;
    newGroup = processId;
    if (success) {
      const successMessage = _get(message, 'title', groupUploadMsg);
      yield put(setUploadMsg(successMessage));
      yield put(createGroupSuccess(newGroup));
    } else {
      const failedMessage = _get(message, 'title', genericErrorMsg);
      yield put(openErrorToast(failedMessage));
      yield put(createGroupFailed());
    }
  } catch (error) {
    let err = error;
    if (error.response) {
      err = yield err.response;
    }
    // clearInputValue();
    yield put(openErrorToast());
    yield put(createGroupFailed(err));
  }
}

const getGroupDetails = ({ groupId, workspaceId }) => {
  const options = {
    method: METHOD_GET,
    params: { group_id: groupId, workspace_id: workspaceId },
  };
  return zfetch(`${GET_GROUP_DETAILS}`, options);
};

export function* getGroupDetailsSaga(action) {
  let groupData = {};

  try {
    const response = yield getGroupDetails(action.payload);
    const jsonResponse = yield response.json();
    const { data } = jsonResponse;
    groupData = data;
  } catch (error) {
    let err = error;
    if (error.response) {
      err = yield err.response;
    }
    yield put(getGroupDetailsFailed(err));
    return;
  }

  yield put(getGroupDetailsSuccess(groupData));
}
